import ActivateRegisterClient from './ActivateRegisterClient'

export const ActivateRegisterClientService = ActivateRegisterClient

